import React, { useState } from 'react';
import { 
  FaVideo, FaPlay, FaShieldAlt, FaCheckCircle, 
  FaChevronDown, FaRegClock, FaYoutube, FaShareAlt 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const VideoClips = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const videosList = [
    {
      title: "Strategic Tax Planning Masterclass: Maximizing Deductions Legally",
      duration: "14:25 mins",
      category: "Tax Advisory",
      date: "June 10, 2026",
      description: "A comprehensive video breakdown of year-round tax planning, capital gains control, and navigating regime selections."
    },
    {
      title: "Investing Beyond Borders: How to Use the LRS Route for Global Stocks",
      duration: "11:50 mins",
      category: "Global Investments",
      date: "May 25, 2026",
      description: "Learn how resident Indians can legally remit funds abroad, hedge against currency risk, and invest in international tech leaders."
    },
    {
      title: "Estate Planning 101: Why Every Family Needs a Will & Private Trust",
      duration: "16:10 mins",
      category: "Estate Planning",
      date: "May 02, 2026",
      description: "An expert guide on protecting assets from probate delays, avoiding family disputes, and securing multi-generational wealth transfer."
    },
    {
      title: "Private Credit & High-Yield Debt: Alternative Assets Explained",
      duration: "12:40 mins",
      category: "Alternative Assets",
      date: "April 18, 2026",
      description: "Discover why sophisticated investors are allocating capital to senior secured private debt and non-bank corporate credit funds."
    },
    {
      title: "The FIRE Movement: Mathematics of Retiring in Your 40s",
      duration: "18:05 mins",
      category: "Financial Planning",
      date: "April 01, 2026",
      description: "Breaking down high savings rates, aggressive equity compounding, and the 4% safe withdrawal rule for early financial freedom."
    },
    {
      title: "Corporate Financial Wellness: Reducing Employee Stress",
      duration: "09:30 mins",
      category: "Corporate Advisory",
      date: "March 15, 2026",
      description: "How employers can implement financial literacy workshops and tax-saving seminars to drive workforce productivity and retention."
    }
  ];

  const faqs = [
    {
      q: "Where can I watch the full-length video clips and webinars?",
      a: "All our video clips are hosted on our official Lotoswealth YouTube channel and embedded directly into our knowledge portal for seamless viewing."
    },
    {
      q: "Are these videos updated with current market and tax regulations?",
      a: "Yes. Our video library is regularly updated to reflect current financial year tax laws, Union Budget announcements, and shifting macroeconomic indicators."
    },
    {
      q: "Can I request a video topic on a specific financial subject?",
      a: "Absolutely! We welcome suggestions from our clients and community. If there's a specific topic on taxation, estate planning, or investments you'd like us to cover, feel free to reach out."
    },
    {
      q: "How can I schedule a consultation after watching a video?",
      a: "If a video raises questions about your personal portfolio or tax strategy, you can click the consultation button at the bottom of the page to speak directly with our advisors."
    }
  ];

  return (
    <main className="video-clips-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Financial Video Clips | Wealth Management Videos in Hyderabad | Lotoswealth</title>

  <meta
    name="description"
    content="Watch informative financial video clips from Lotoswealth covering Wealth Management, Portfolio Management Services (PMS), Mutual Funds, Stock Market, Financial Planning, Tax Planning, Retirement Planning, Home Loans, Car Loans, Education Loans, and investment strategies in Hyderabad."
  />

  <meta
    name="keywords"
    content="Financial Videos Hyderabad, Investment Videos Hyderabad, Wealth Management Videos Hyderabad, Financial Planning Videos Hyderabad, Portfolio Management Videos Hyderabad, PMS Videos Hyderabad, Mutual Funds Videos Hyderabad, Stock Market Videos Hyderabad, Tax Planning Videos Hyderabad, Retirement Planning Videos Hyderabad, Estate Planning Videos Hyderabad, Home Loan Videos Hyderabad, Car Loan Videos Hyderabad, Education Loan Videos Hyderabad, Investment Tips Videos Hyderabad, Personal Finance Videos Hyderabad, Financial Education Hyderabad, Wealth Creation Videos Hyderabad, Lotoswealth Videos"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/video-clips"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/video-clips"
  />
  <meta
    property="og:title"
    content="Financial Video Clips | Wealth Management Videos | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Watch expert financial videos on Wealth Management, Mutual Funds, Stock Market, Financial Planning, Tax Planning, Retirement Planning, Portfolio Management, and investment strategies."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Financial Video Clips | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Explore financial video clips featuring Wealth Management, Financial Planning, Stock Market insights, Mutual Funds, Retirement Planning, Tax Planning, and investment education."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/video-clips.jpg" 
            alt="Financial Video Clips and Masterclasses" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Video Clips & Masterclasses
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Expert Financial Guidance in Easy-to-Watch Video Format
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth's Video Hub. Complex financial strategies, tax guidelines, and market updates are often best explained visually. Our curated collection of video clips and masterclasses breaks down wealth management into engaging, digestible masterclasses.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether you want to learn about offshore investing, private equity due diligence, the FIRE movement, or estate trust structures, our expert-led video briefings give you actionable insights on demand.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Watch, learn, and empower your financial decisions with our comprehensive multimedia resource center.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY VIDEO LEARNING MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Visualizing Wealth Management Strategies
              </h2>
              <p className="text-muted line-height-lg">
                Reading complex financial documentation can sometimes feel daunting. Video learning brings concepts to life, offering step-by-step breakdowns, visual asset models, and expert explanations that are easy to absorb.
              </p>
              <p className="text-muted line-height-lg">
                Our video library is designed to make financial literacy accessible to everyone—from young professionals starting their first SIPs to ultra-high-net-worth individuals evaluating alternative investment funds.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Benefits of Our Video Library</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Expert Breakdowns:</strong> Certified advisors explaining core concepts clearly.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>On-Demand Learning:</strong> Watch masterclasses at your own pace, anytime.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Visual Frameworks:</strong> Graphical representations of tax strategies and portfolios.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Regular Additions:</strong> Fresh video clips released weekly on current market topics.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. FEATURED VIDEOS GRID (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🎬 Featured Video Masterclasses</h2>
            <p className="text-white">Watch our latest expert briefings and financial education clips.</p>
          </div>

          <div className="row g-4">
            
            {videosList.map((video, index) => (
              <div key={index} className="col-lg-4 col-md-6 animate-slide-up delay-1">
                <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4 d-flex flex-column justify-content-between">
                  <div>
                    {/* Simulated Video Thumbnail Box */}
                    <div className="position-relative bg-dark rounded-3 overflow-hidden mb-3 d-flex align-items-center justify-content-center" style={{ height: '180px' }}>
                      <div className="position-absolute top-0 start-0 m-2">
                        <span className="badge bg-teal text-white px-2 py-1 small">{video.category}</span>
                      </div>
                      <div className="position-absolute bottom-0 end-0 m-2">
                        <span className="badge bg-dark text-white px-2 py-1 small d-flex align-items-center">
                          <FaRegClock className="me-1 text-teal" /> {video.duration}
                        </span>
                      </div>
                      <div className="btn btn-teal rounded-circle p-3 shadow text-white d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                        <FaPlay size={18} className="ms-1" />
                      </div>
                    </div>

                    <h5 className="fw-bold mb-2 text-dark">{video.title}</h5>
                    <p className="text-muted small mb-3">{video.description}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                    <span className="text-muted small">{video.date}</span>
                    <button className="btn btn-outline-teal btn-sm d-flex align-items-center gap-1 fw-bold">
                      <FaYoutube className="text-danger" /> Watch Clip
                    </button>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* =========================================
          4. VIDEO TOPICS BY CATEGORY (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Browse Video Series</h2>
            <p className="text-light opacity-75">Targeted masterclasses categorized by wealth management pillars.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Tax Strategy Briefings</h5>
                <p className="small text-muted mb-0">Video tutorials on ITR filing, capital gains harvesting, and corporate tax optimization strategies.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Global Investment Guides</h5>
                <p className="small text-muted mb-0">Step-by-step walkthroughs on LRS remittances, international ETFs, and cross-border portfolio diversification.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Alternative Asset Deep Dives</h5>
                <p className="small text-muted mb-0">Explaining private equity, private credit, AIFs, and REITs through expert interviews and case studies.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Estate Planning & Trusts</h5>
                <p className="small text-muted mb-0">Visual guides on structuring Wills, setting up private family trusts, and protecting multi-generational wealth.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">FIRE & Retirement Masterclasses</h5>
                <p className="small text-muted mb-0">Actionable sessions on calculating your FIRE number, aggressive compounding, and post-retirement SWP strategies.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Watches Our Videos?</h3>
              <p className="text-muted small mb-4">Our video library attracts a diverse community of learners:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "Visual Learners & Investors", "High Net Worth Individuals",
                  "Salaried Professionals", "Entrepreneurs & Founders",
                  "FIRE Movement Seekers", "Retirees & Pensioners",
                  "Global Asset Explorers", "Lifelong Financial Students"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Watch Lotoswealth Masterclasses?</h3>
                <p className="text-muted small mb-4">We believe financial education should be engaging and crystal clear. Viewers choose our video content because we offer:</p>
                <div className="row g-3">
                  {[
                    "Engaging, High-Quality Visual Explanations", "Expert Insights by Certified Wealth Advisors",
                    "Bite-Sized Clips & Deep-Dive Masterclasses", "Actionable Investment Frameworks",
                    "Regularly Updated Market Content", "Completely Free Access to Knowledge",
                    "Clear, Jargon-Free Breakdowns", "Dedicated Support for Follow-Up Questions"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding our Video Clips & Masterclasses</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Turn Insights Into Action?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Don't just watch masterclasses—apply them directly to your personal wealth strategy. Schedule a consultation with our experts today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule a Personal Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default VideoClips;